import React, {  useState } from "react";
import { Field } from "formik";
import {toAbsoluteUrl} from "../../../../../_helpers";
import SVG from "react-inlinesvg";
import {OverlayTrigger,Tooltip} from "react-bootstrap";
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";

export const ShapeLab = ({labData,language}) => {
    const [shape] = useState( labData.length !== 0 && labData[0].lab_shape !== null ? labData[0].lab_shape : [] );
  
    const newShapeData =shape.length!==0?shape.split(',').map((value,index) => {
        return {
            id: index,
            shape:value,
            multilingualshape:language[`${value.toUpperCase()}`] || value.toUpperCase()
        }
    }):null
    const [shapeImages] = useState( labData.length !== 0 && labData[0].shapeImages !== null ? labData[0].shapeImages : [] );    

    const [shapeLimit, setShapeLimit] = useState(12);
    const showMoreShape = () => setShapeLimit(newShapeData.length);
    const showLessShape = () => setShapeLimit(12);

    return (
        <>
        
            <div className="row">
                <div className="col-12 font-size-lg font-weight-bold mb-3 text-center">{language.CCMODE_THEME1_SEARCHDIAMOND_SHAPE}</div>
                <div className="col-12 text-center">
                    {newShapeData ? newShapeData.slice(0, shapeLimit).map((item) => (
                        <OverlayTrigger placement="top" key={item.id} overlay={<Tooltip id="tooltip" >{item.multilingualshape}</Tooltip>} >
                            <label className="search_btn_check">
                                <Field type="checkbox" name="Shape" id={`${item.shape}_shape`} value={item.shape}/>
                                {/* <span></span> */}
                                <div className="shapeBox selectBox">
                                    <SVG src={shapeImages?.svg?.[item.shape] || ""} />
                                    <br/>
                                    {/* <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip" >{item.multilingualshape}</Tooltip>} > */}
                                        <span className="text-uppercase text-truncate">{item.multilingualshape}</span>
                                    {/* </OverlayTrigger> */}
                                </div>
                            </label>
                        </OverlayTrigger>
                    )):null}
                    {newShapeData && newShapeData.length > 12 &&
                        <span className="search_btn_check" onClick={shapeLimit === newShapeData.length ? showLessShape : showMoreShape}>
                            <div className="shapeBox selectBox">
                                {shapeLimit === newShapeData.length ? <CiCircleMinus /> : <CiCirclePlus />}
                                <br/>
                                <span className="text-uppercase text-truncate">{shapeLimit === newShapeData.length ? "Less" : "More"}</span>
                            </div>
                        </span>
                    }
                </div>
            </div>
        </>
    );
};
